import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import './index.css';
import registerServiceWorker from './registerServiceWorker';
import App from './App';
import createSagaMiddleware from 'redux-saga';
import rootReducer from './duck/reducers';
import {
  watchNews,
  watchSingleNews,
  watchReviews,
  watchSingleReview,
  watchT3,
  watchSingleT3,
  // watchBestOf,
  // watchSingleBestOf,
  watchAuthorInfo,
  watchTagsPostList,
  watchHome,
  watchGallery,
  watchInternet,
  watchSearch
} from './duck/sagas';

const composeEnhancers =
  process.env.NODE_ENV === 'development'
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    : null || compose;

const sagaMiddleware = createSagaMiddleware();

const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(thunk, sagaMiddleware))
);

sagaMiddleware.run(watchNews);
sagaMiddleware.run(watchSingleNews);
sagaMiddleware.run(watchReviews);
sagaMiddleware.run(watchSingleReview);
sagaMiddleware.run(watchT3);
sagaMiddleware.run(watchSingleT3);
sagaMiddleware.run(watchInternet);
// sagaMiddleware.run(watchSingleT3);
// sagaMiddleware.run(watchBestOf);
// sagaMiddleware.run(watchSingleBestOf);
sagaMiddleware.run(watchAuthorInfo);
sagaMiddleware.run(watchTagsPostList);
sagaMiddleware.run(watchHome);
sagaMiddleware.run(watchGallery);
sagaMiddleware.run(watchSearch);

const app = (
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>
);

ReactDOM.render(app, document.getElementById('root'));
registerServiceWorker();
